<template>
  <div class="dea-input dea-input--input-select" :class="{ 'dea-input--disabled': disabled }">
    <div class="dea-input__labels">
      <label class="dea-input__label-wrapper" :for="id">
        {{ label }}
        <span v-if="supportLabel" class="dea-input__support-label">{{ supportLabel }}</span>
      </label>
    </div>
    <div class="dea-input__wrapper">
      <select :id="id" :name="name" :disabled="disabled" @change="handleInput">
        <option value>{{ placeholder }}</option>
        <slot />
      </select>
      <div class="dea-input__icon dea-ico-freccia-down"></div>
      <div
        v-if="icon"
        :class="[
          getIcon(icon),
          {
            'dea-input__icon--textarea': type == 'textarea',
            'dea-input__icon--error': state === 'error',
            'dea-input__icon--success': state === 'success',
          },
        ]"
        class="dea-input__icon dea-input__icon--select"
      ></div>
    </div>
    <p :class="{ 'dea-input__error-message': state === 'error' }" class="dea-input__support-message">{{ message }}</p>
  </div>
</template>

<script>
/**
 *
 */
export default {
  name: "InputSelect",
  props: {
    /**
     * The type of the form input field.
     * `text, number, email`
     */
    type: {
      type: String,
      default: "text",
      validator: value => {
        return value.match(/(text|textarea)/);
      },
    },
    /**
     * The placeholder value for the form input field.
     */
    placeholder: {
      type: String,
      default: "",
    },
    /**
     * The label of the form input field.
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * The support label of the form input field.
     */
    supportLabel: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    /**
     * Unique identifier of the form input field.
     */
    id: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    state: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleInput(event) {
      // allow using v-model syntax
      this.$emit("input", event.target.value);
      // explicit event handling with something like <InputSelect id="category" @change="startFilterFromSelect($event)">
      this.$emit("change", event);
    },
    getIcon(icon) {
      return `dea-ico-${icon}`;
    },
  },
};
</script>
